import { useState } from "react";
import { toast } from "react-toastify";
import { BasicButton } from "./BasicButton";

interface Props {
    notes?: string[] | string | null;
    onChange: (notes: string[]) => void;
    label?: string;
    placeholder?: string;
}

export const MultipleNotes = ({ notes, onChange, label = "Notas", placeholder = "Escribe una nota..." }: Props) => {
    const [currentNote, setCurrentNote] = useState("");

    const normalizedNotes = (() => {
        if (Array.isArray(notes)) {
            return notes.map(String).filter(note => note.trim() !== "");
        }

        if (typeof notes !== "string" || notes.trim() === "") {
            return [];
        }

        try {
            const parsed = JSON.parse(notes);
            if (Array.isArray(parsed)) {
                return parsed.map(String).filter(note => note.trim() !== "");
            }
        } catch {
            // El valor puede estar almacenado como texto separado por saltos de línea.
        }

        return notes.split("\n").map(note => note.trim()).filter(Boolean);
    })();

    const addNote = () => {
        const note = currentNote.trim();
        if (!note) {
            toast.warning("La nota no puede estar vacía");
            return;
        }

        onChange([...normalizedNotes, note]);
        setCurrentNote("");
    };

    const removeNote = (index: number) => {
        onChange(normalizedNotes.filter((_, noteIndex) => noteIndex !== index));
    };

    return (
        <div className="col-md-12">
            <label>{label}</label>
            <div className="card mb-3 border">
                <div className="card-body p-3">
                    {normalizedNotes.length === 0 ? (
                        <p className="text-muted mb-2 font-size-13">No hay notas agregadas.</p>
                    ) : (
                        <ul className="list-group list-group-flush mb-2" style={{ maxHeight: "200px", overflowY: "auto" }}>
                            {normalizedNotes.map((note, index) => (
                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center p-2">
                                    <span className="text-break font-size-13">{note}</span>
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm border-0 py-0 px-2"
                                        onClick={() => removeNote(index)}
                                        title="Eliminar nota"
                                    >
                                        <i className="ri-delete-bin-line" />
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}

                    <div className="mt-2">
                        <textarea
                            className="form-control mb-2"
                            placeholder={placeholder}
                            value={currentNote}
                            onChange={(event) => setCurrentNote(event.target.value)}
                            rows={2}
                        />
                        <div className="d-flex justify-content-end">
                            <BasicButton icon="ri-add-line" eventClick={addNote} clase="success">
                                Agregar Nota
                            </BasicButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
